import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'reactstrap';
import { connect } from 'react-redux';
import Modal from '../../../common/modal/Modal';
import { putParcelsToPickupByItemLegalAbandonment } from '../../../../actions/cargo/CargoPickup';
import withEndpointAuthorization from '../../authorization/withEndPointAuthorization';
import { PUT } from '../../../../config/permissions';
import CargoPickupModalLegalAbandonment from '../cargo-pickup/CargoPickupModalLegalAbandonment';
import { generatePutParcelPickupByItemLegalAbandonment } from '../../../../config/endpoints';

export const DeliverParcelButtonLegalAbandonment = ({
  parcel,
  dispatchPutParcelsToPickupByItemLegalAbandonment,
}) => {
  const [showModal, setShowModal] = useState(false);
  const [modalBody, setModalBody] = useState(null);

  const getConsigneeData = () => {
    const { consigneeCustomer, secondaryConsigneeCustomer } = parcel;

    const consigneeCustomerData = {
      value: consigneeCustomer.id || '',
      label:
        `${consigneeCustomer.fullName} | ${consigneeCustomer.identificationType.name}: ${consigneeCustomer.idDocumentNumber}` ||
        '',
    };

    if (!secondaryConsigneeCustomer) {
      return [consigneeCustomerData];
    }

    const secondaryConsigneeCustomerData = {
      value: secondaryConsigneeCustomer.id || '',
      label:
        `${secondaryConsigneeCustomer.fullName} | ${secondaryConsigneeCustomer.identificationType.name}: ${secondaryConsigneeCustomer.idDocumentNumber}` ||
        '',
    };

    return [consigneeCustomerData, secondaryConsigneeCustomerData];
  };

  const onModalSubmit = async ({
    secretCode,
    paymentMethod,
    voucherCode,
    items,
    deliveredCustomer,
  }) => {
    await dispatchPutParcelsToPickupByItemLegalAbandonment({
      parcelId: parcel.id,
      secretCode,
      paymentMethod,
      voucherCode,
      items,
      deliveredCustomerId: deliveredCustomer.value,
      paymentMethodId: paymentMethod ? paymentMethod.value : null,
    });

    setShowModal(false);
  };

  const onCancel = () => {
    setShowModal(false);
  };

  const onShowModal = async () => {
    const newModalBody = (
      <CargoPickupModalLegalAbandonment
        parcel={parcel}
        onCancel={onCancel}
        handleProcess={onModalSubmit}
        options={getConsigneeData()}
      />
    );
    setModalBody(newModalBody);
    setShowModal(true);
  };

  return (
    <>
      <Button color="success" onClick={onShowModal}>
        <i className="fa fa-plus-circle" /> Entregar Abandono Legal
      </Button>
      <Modal
        show={showModal}
        title="Entregar encomienda sin reclamar"
        onClickClose={() => setShowModal(false)}
        body={modalBody}
        size="lg"
      />
    </>
  );
};

DeliverParcelButtonLegalAbandonment.propTypes = {
  parcel: PropTypes.instanceOf(Object).isRequired,
  dispatchPutParcelsToPickupByItemLegalAbandonment: PropTypes.func.isRequired,
};

const mapDispatchToProps = {
  dispatchPutParcelsToPickupByItemLegalAbandonment:
    putParcelsToPickupByItemLegalAbandonment,
};

const connectedComponent = connect(
  null,
  mapDispatchToProps,
)(DeliverParcelButtonLegalAbandonment);

export default withEndpointAuthorization({
  url: generatePutParcelPickupByItemLegalAbandonment(0),
  permissionType: PUT,
})(connectedComponent);
